import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '@/api/util'
import { Api, Cruz } from '@cruz-com/lookup'

export const saveSearch = {
  save,
  unSave
}

// save
export async function save(data: Cruz.SavedQuery): Promise<Api.Result<any>> {
  try {
    const res = await fetch(`${baseURL}/my/save-search`, {
      method: 'POST',
      headers: await fetchHeaders(),
      body: JSON.stringify(data)
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(formatFetchError(d))
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

// delete
export async function unSave(id: string | null): Promise<Api.Result<Cruz.User>> {
  try {
    const res = await fetch(`${baseURL}/my/save-search/${id}`, {
      method: 'DELETE',
      headers: await fetchHeaders(),
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}


